var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '@corti/theme';
import { Card } from 'lib/cortiUI';
export const GradientCard = (_a) => {
    var { gradientColor } = _a, rest = __rest(_a, ["gradientColor"]);
    const { palette } = useTheme();
    const cardStyle = {
        background: `linear-gradient(57deg, ${gradientColor} 0%, ${palette.background.card} 48%, ${palette.background.card} 100%)`,
    };
    return React.createElement(Card, Object.assign({ style: cardStyle }, rest));
};
